import { render } from "./EvaluationTwo.vue?vue&type=template&id=3fb37334"
import script from "./EvaluationTwo.vue?vue&type=script&lang=js"
export * from "./EvaluationTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__